var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQMenuButtonMeatballVertical = function SvgQMenuButtonMeatballVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#140F33"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18.5,
    r: 1.5
  }))));
};
export { SvgQMenuButtonMeatballVertical as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Im1lbnUgYnV0dG9uIj4KPGNpcmNsZSBpZD0iRWxsaXBzZSAxMCIgY3g9IjEyIiBjeT0iNS41IiByPSIxLjUiIGZpbGw9IiMxNDBGMzMiLz4KPGNpcmNsZSBpZD0iRWxsaXBzZSAxMSIgY3g9IjEyIiBjeT0iMTIiIHI9IjEuNSIgZmlsbD0iIzE0MEYzMyIvPgo8Y2lyY2xlIGlkPSJFbGxpcHNlIDEyIiBjeD0iMTIiIGN5PSIxOC41IiByPSIxLjUiIGZpbGw9IiMxNDBGMzMiLz4KPC9nPgo8L3N2Zz4K";